import { IChannel } from '../models/ichannel';
import { IIntersectionViewModel, ILayout, IPointerViewModel, ITraceViewModel } from '../models/interfaces';
import { IntersectionViewModel } from './intersection-viewmodel';

export class PointerViewModel implements IPointerViewModel {
    // data members

    intersection: IIntersectionViewModel;

    opacity: number = 0;
    selected: boolean = false;
    textX: number = 0;
    tooltip: string = '';
    tooltipOpacity: number = 0;

    layout: ILayout;
    trace: ITraceViewModel;
    channel: IChannel;

    index;

    // constructor

    constructor(layout: ILayout, trace: ITraceViewModel, channel: IChannel, positionX: number, index: number) {
        this.opacity = 0;
        this.tooltipOpacity = 0;

        this.layout = layout;
        this.trace = trace;
        this.channel = channel;
        this.index = index;

        this.intersection = new IntersectionViewModel(this);
        this.positionX = positionX;
    }

    // properties

    private _positionX = 0;
    get positionX() {
        return this._positionX;
    }
    set positionX(positionX) {
        const leadWidth = this.layout?.context?.leadWidth ?? 0;
        if (positionX < 0) positionX = 0;

        if (positionX > leadWidth) positionX = leadWidth;

        this._positionX = positionX;

        this.intersection.positionX = this.positionX;

        this.tooltip =
            '(x: ' + this.intersection.positionX.toFixed(3) + ', y: ' + this.intersection.positionY.toFixed(3) + ')';
    }

    get currentIntersection() {
        return this.intersection.getIntersection(this.positionX);
    }

    // public functions

    update() {
        this.intersection.update();
        this.intersection.positionX = this.positionX;

        this.tooltip =
            '(x: ' + this.intersection.positionX.toFixed(3) + ', y: ' + this.intersection.positionY.toFixed(3) + ')';
    }
}
